import {
    FETCH_INTENSITY_MINUTES_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS,
    FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL,
    FETCH_INTENSITY_MINUTES_HOURLY_DATA,
    FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    intensityMinutesData: null,
    intensityMinutesDataFetching: false,
    intensityMinutesDataFetchFail: false,

    intensityMinutesDailyData: null,
    intensityMinutesDailyDataFetching: false,
    intensityMinutesDailyDataFetchFail: false,

    intensityMinutesWeeklyData: null,
    intensityMinutesWeeklyDataFetching: false,
    intensityMinutesWeeklyDataFetchFail: false
};

// DAILY DATA
const intensityMinutesDataFetching = (state) => ({
    ...state,
    intensityMinutesDataFetching: true,
    intensityMinutesDataFetchFail: false
});

const intensityMinutesDataFetchFinished = (state, action) => ({
    ...state,
    intensityMinutesData: action.intensityMinutesData,
    intensityMinutesDataFetching: false,
    intensityMinutesDataFetchFail: false
});

const intensityMinutesDataFetchFail = (state, action) => ({
    ...state,
    intensityMinutesData: action.intensityMinutesData,
    intensityMinutesDataFetching: false,
    intensityMinutesDataFetchFail: true
});

// DAILY STATS DATA
const intensityMinutesDailyDataFetching = (state) => ({
    ...state,
    intensityMinutesDailyDataFetching: true,
    intensityMinutesDailyDataFetchFail: false
});

const intensityMinutesDailyDataFetchFinished = (state, action) => ({
    ...state,
    intensityMinutesDailyData: action.intensityMinutesDailyData,
    intensityMinutesDailyDataFetching: false,
    intensityMinutesDailyDataFetchFail: false
});

const intensityMinutesDailyDataFetchFail = (state, action) => ({
    ...state,
    intensityMinutesDailyData: action.intensityMinutesDailyData,
    intensityMinutesDailyDataFetching: false,
    intensityMinutesDailyDataFetchFail: true
});

// WEEKLY DATA
const intensityMinutesWeeklyDataFetching = (state) => ({
    ...state,
    intensityMinutesWeeklyDataFetching: true,
    intensityMinutesWeeklyDataFetchFail: false
});

const intensityMinutesWeeklyDataFetchFinished = (state, action) => ({
    ...state,
    intensityMinutesWeeklyData: action.intensityMinutesWeeklyData,
    intensityMinutesWeeklyDataFetching: false,
    intensityMinutesWeeklyDataFetchFail: false
});

const intensityMinutesWeeklyDataFetchFail = (state, action) => ({
    ...state,
    intensityMinutesWeeklyData: action.intensityMinutesWeeklyData,
    intensityMinutesWeeklyDataFetching: false,
    intensityMinutesWeeklyDataFetchFail: true
});

const fetchIntensityMinutesHourlyData = (state) => {
    return {
        ...state,
        intensityMinutesHourlyDataFetching: true,
        intensityMinutesHourlyDataError: false
    };
};

const fetchIntensityMinutesHourlyDataDone = (state, action) => {
    return {
        ...state,
        intensityMinutesHourlyData: action.intensityMinutesHourlyData,
        intensityMinutesHourlyDataFetching: false,
        intensityMinutesHourlyDataError: action.error
    };
};

// selectors
const getIntensityMinutesState = (state) => {
    return state.intensityMinutes;
};

export const getIntensityMinutesData = (state) =>
    state.intensityMinutes.intensityMinutesData ? state.intensityMinutes.intensityMinutesData : null;
export const isIntensityMinutesDataFetching = (state) => state.intensityMinutes.intensityMinutesDataFetching;
export const isIntensityMinutesDataFetchFail = (state) => state.intensityMinutes.intensityMinutesDataFetchFail;

export const getIntensityMinutesDailyData = (state) =>
    state.intensityMinutes.intensityMinutesDailyData ? state.intensityMinutes.intensityMinutesDailyData : null;
export const isIntensityMinutesDailyDataFetching = (state) => state.intensityMinutes.intensityMinutesDailyDataFetching;
export const isIntensityMinutesDailyDataFetchFail = (state) =>
    state.intensityMinutes.intensityMinutesDailyDataFetchFail;

export const getIntensityMinutesWeeklyData = (state) =>
    state.intensityMinutes.intensityMinutesWeeklyData ? state.intensityMinutes.intensityMinutesWeeklyData : null;
export const isIntensityMinutesWeeklyDataFetching = (state) =>
    state.intensityMinutes.intensityMinutesWeeklyDataFetching;
export const isIntensityMinutesWeeklyDataFetchFail = (state) =>
    state.intensityMinutes.intensityMinutesWeeklyDataFetchFail;

export const getIntensityMinutesHourlyData = (state) => {
    const intensityMinutes = getIntensityMinutesState(state);
    return intensityMinutes.intensityMinutesHourlyData;
};
export const isIntensityMinutesHourlyDataFetching = (state) => {
    const intensityMinutes = getIntensityMinutesState(state);
    return intensityMinutes.intensityMinutesHourlyDataFetching;
};
export const isIntensityMinutesHourlyDataFetchFail = (state) => {
    const intensityMinutes = getIntensityMinutesState(state);
    return intensityMinutes.intensityMinutesHourlyDataError;
};

const handlers = {
    [FETCH_INTENSITY_MINUTES_DATA_FETCHING]: intensityMinutesDataFetching,
    [FETCH_INTENSITY_MINUTES_DATA_SUCCESS]: intensityMinutesDataFetchFinished,
    [FETCH_INTENSITY_MINUTES_DATA_FAIL]: intensityMinutesDataFetchFail,

    [FETCH_INTENSITY_MINUTES_DAILY_DATA_FETCHING]: intensityMinutesDailyDataFetching,
    [FETCH_INTENSITY_MINUTES_DAILY_DATA_SUCCESS]: intensityMinutesDailyDataFetchFinished,
    [FETCH_INTENSITY_MINUTES_DAILY_DATA_FAIL]: intensityMinutesDailyDataFetchFail,

    [FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FETCHING]: intensityMinutesWeeklyDataFetching,
    [FETCH_INTENSITY_MINUTES_WEEKLY_DATA_SUCCESS]: intensityMinutesWeeklyDataFetchFinished,
    [FETCH_INTENSITY_MINUTES_WEEKLY_DATA_FAIL]: intensityMinutesWeeklyDataFetchFail,

    [FETCH_INTENSITY_MINUTES_HOURLY_DATA]: fetchIntensityMinutesHourlyData,
    [FETCH_INTENSITY_MINUTES_HOURLY_DATA_DONE]: fetchIntensityMinutesHourlyDataDone
};

export default function intensityMinutes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
